import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/service/auth.service';
import { Router } from '@angular/router';
import { DesignService } from 'src/app/service/design.service';
import { UserService } from 'src/app/service/user.service';
import { WorkspaceModel } from 'src/app/model/workspace.model';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  workspaces: WorkspaceModel[] = [];
  selectedWorkspace: string;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private designService: DesignService,
    private userService: UserService) { }

    
  get isAdminUser(): boolean {
    return this.authService.hasRole("admin")
  }

  get logoUrl(): string {
    return this.designService.getLogoUrl()
  }

  ngOnInit() {
    this.selectAuthUserWorkspace();

    this.userService.getWorkspaces().subscribe(data => {
      this.workspaces = data;
    });
  }

  getUserName(): string {
    let user = this.authService.getUser()

    if(user) {
      return user.name
    }
  }

  getWorkspaceName(workspace: WorkspaceModel): string {
    let name = workspace.tenantName

    if(name != workspace.workspaceName) {
      name += `- ${workspace.workspaceName}`
    }

    return name
  }

  onWorkspaceChange(workspaceId: string) {
    const selectedWorkspace = this.workspaces.find(workspace => workspace.workspaceId === workspaceId);

    this.userService.impersonate(selectedWorkspace.tenantId, selectedWorkspace.workspaceId)
      .pipe(
        catchError((error) => {
            this.selectAuthUserWorkspace();
            return of(null);
        })
      )
      .subscribe((token: any) => {
        sessionStorage.clear();
        this.authService.logout();
        this.authService.setAuthToken(token.bearerToken);

        window.location.href = '/dashboard';
      });
  }

  getUserInitials(): string {
    const name = this.getUserName().trim();
    if (!name) return ''; 
  
    const parts = name.split(' ').filter(n => n.length > 0);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  
    return '';
  }
  
  private selectAuthUserWorkspace() {
    let user = this.authService.getUser();
    this.selectedWorkspace = user.workspaceId;
  }

  logout() {
    sessionStorage.clear();
    this.authService.logout();
    this.router.navigate(['login']);
  }
}
  